/* Oneso Shop Video — product panel: photos, prices, sizes and quantities, add to the store's cart (SparkLayer). Same as the live player.
   View cart (in the message after adding) slides the SparkLayer cart in on the right, over the player - it does not open a new page. */
(function () {
'use strict';
var L = window.BSVL; if (!L || L.fill) return;
var d = L.d, mk = L.mk, btn = L.btn, stop = L.stop, money = L.money, base = L.base;
function fill(body, foot, pr, flash, onCart) {
body.textContent = ''; foot.textContent = '';
var canOrder = L.loggedIn(), showPrice = canOrder;
if (pr.images && pr.images.length) {
var g = mk('div', 'bsv-g');
pr.images.slice(0, 8).forEach(function (src, n) { var im = mk('img'); im.setAttribute('data-src', L.norm(src)); im.src = L.sized(src, 600); im.alt = pr.title + ' photo ' + (n + 1); im.loading = n ? 'lazy' : 'eager'; g.appendChild(im); });
body.appendChild(g);
}
body.appendChild(mk('div', 'bsv-h', pr.title));
var prices = mk('div', 'bsv-pr');
if (showPrice) prices.appendChild(mk('span', null, 'WHOLESALE: ' + (pr.price_varies ? 'from ' : '') + money(pr.price / 100)));
body.appendChild(prices);
L.pdp(pr.handle).then(function (x) { if (x.msrp) prices.appendChild(mk('span', null, 'MSRP: ' + money(x.msrp))); });
var multi = (pr.options || []).map(function (o) { return (o.values || []).length > 1; }), qty = {}, sum = mk('span', 'bsv-sum'), add = mk('button', 'bsv-add', 'Add to cart');
add.type = 'button'; add.disabled = true;
var multiN = multi.filter(Boolean).length, di = -1, sel = null;
if (multiN >= 2) { (pr.options || []).forEach(function (o, n) { if (di < 0 && multi[n] && /colou?r/i.test(o.name || '')) di = n; }); if (di < 0) di = multi.indexOf(true); }
function fullLabel(v) { var parts = (v.options || []).filter(function (_, n) { return multi[n]; }); return parts.length ? parts.join(' / ') : v.title; }
function label(v) { var parts = (v.options || []).filter(function (_, n) { return multi[n] && n !== di; }); return parts.length ? parts.join(' / ') : (pr.variants.length > 1 ? v.title : 'Quantity'); }
function total() {
var n = 0, cents = 0;
pr.variants.forEach(function (v) { var q = qty[v.id] || 0; n += q; cents += q * v.price; });
add.disabled = !n;
sum.textContent = n ? (n + (n === 1 ? ' item' : ' items') + (showPrice ? ' · ' + money(cents / 100) : '')) : 'Choose sizes and quantities';
}
if (canOrder) {
var list = mk('div'), th = mk('div', 'bsv-th');
th.appendChild(mk('span', null, pr.variants.length > 1 ? ((pr.options || []).filter(function (_, n) { return multi[n] && n !== di; }).map(function (o) { return o.name; }).join(' / ') || 'Option') : 'Item'));
if (showPrice) th.appendChild(mk('span', 'bsv-vp', 'Price')); th.appendChild(mk('span', null, 'Qty'));
if (di >= 0) {
var opt = pr.options[di], first = pr.variants.filter(function (v) { return v.available; })[0] || pr.variants[0];
sel = first.options[di];
var dl = mk('label', 'bsv-dd'), dsel = mk('select');
(opt.values || []).forEach(function (val) { var o = mk('option', null, val); o.value = val; dsel.appendChild(o); });
dsel.value = sel; dsel.setAttribute('aria-label', opt.name || 'Option'); dsel.addEventListener('click', stop);
dsel.addEventListener('change', function () {
sel = dsel.value; rows();
var hit = pr.variants.filter(function (v) { return v.options[di] === sel && v.featured_image && v.featured_image.src; })[0], g0 = body.querySelector('.bsv-g');
if (hit && g0) { var src = hit.featured_image.src, im0 = [].filter.call(g0.querySelectorAll('img'), function (im) { return im.getAttribute('data-src') === L.norm(src); })[0]; if (!im0) { im0 = mk('img'); im0.className = 'bsv-ok'; im0.setAttribute('data-src', L.norm(src)); im0.src = L.sized(src, 600); im0.alt = pr.title + ' ' + sel; } g0.insertBefore(im0, g0.firstChild); g0.scrollLeft = 0; }
});
dl.appendChild(mk('span', null, opt.name || 'Option')); dl.appendChild(dsel); body.appendChild(dl);
}
var rows = function () { list.textContent = ''; list.appendChild(th); pr.variants.forEach(function (v) { if (di >= 0 && v.options[di] !== sel) return; addRow(v); }); };
var addRow = function (v) {
var row = mk('div', 'bsv-vr'); row.appendChild(mk('span', null, label(v)));
if (showPrice) row.appendChild(mk('span', 'bsv-vp', money(v.price / 100)));
if (!v.available) { row.appendChild(mk('span', 'bsv-so', 'Sold out')); list.appendChild(row); return; }
var rule = v.quantity_rule || {}, step = rule.increment || 1, min = rule.min || 1, max = rule.max || 9999;
var stp = mk('span', 'bsv-st'), num = mk('span', null, String(qty[v.id] || 0)); num.setAttribute('aria-live', 'polite');
function set(q) { q = q < min ? (q > (qty[v.id] || 0) ? min : 0) : Math.min(q, max); qty[v.id] = q; num.textContent = String(q); total(); }
stp.appendChild(btn('', '−', 'Fewer ' + label(v), function () { set((qty[v.id] || 0) - step); }));
stp.appendChild(num);
stp.appendChild(btn('', '+', 'More ' + label(v), function () { set((qty[v.id] || 0) + step); }));
row.appendChild(stp); list.appendChild(row);
};
rows();
body.appendChild(list);
var msg = mk('div', 'bsv-smsg'); msg.setAttribute('role', 'status'); body.appendChild(msg);
add.addEventListener('click', function (e) {
e.stopPropagation();
var chosen = pr.variants.filter(function (v) { return qty[v.id] > 0; });
if (!chosen.length) return;
var count = chosen.reduce(function (a, v) { return a + qty[v.id]; }, 0), sp = window.spark;
add.disabled = true; add.textContent = 'Adding…'; msg.textContent = '';
function done(text, warn) {
msg.className = 'bsv-smsg' + (warn ? '' : ' bsv-ok'); msg.textContent = text + ' ';
var vc = mk('a', 'bsv-lk', 'View cart'); vc.href = base + 'cart'; vc.target = '_blank'; vc.rel = 'noopener';
vc.addEventListener('click', function (ev) { ev.stopPropagation(); if (viewCart(vc, onCart)) ev.preventDefault(); });   /* the cart slides in on the right; a new tab only without SparkLayer */
msg.appendChild(vc);
qty = {}; [].forEach.call(list.querySelectorAll('.bsv-st span'), function (s) { s.textContent = '0'; });
add.textContent = 'Add to cart'; total();
markCart(pr.handle);
}
function failed(err) { msg.className = 'bsv-smsg'; msg.textContent = String((err && err.message) || 'Could not add to cart'); add.textContent = 'Add to cart'; total(); }
if (sp && typeof sp.updateCart === 'function') {
var noSku = chosen.filter(function (v) { return !v.sku; });
if (noSku.length) { failed(new Error('These sizes have no SKU and cannot be ordered here: ' + noSku.map(fullLabel).join(', '))); return; }
var bySku = {}; chosen.forEach(function (v) { bySku[v.sku] = v; });
Promise.resolve(sp.updateCart({ products: chosen.map(function (v) { return { sku: v.sku, adjustQuantity: qty[v.id] }; }) }, true, true)).then(function (res) {
if (!res) throw new Error('Could not add to your order. Please try again.');
var bad = [], changed = [];
[].concat(res).forEach(function (line) {
var v = line && bySku[line.sku], types = ((line && line.messages) || []).map(function (m) { return m && m.type; });
if (!v) return;
if (types.indexOf('not-found') > -1 || types.indexOf('unavailable') > -1) bad.push(fullLabel(v));
else if (types.indexOf('qty-unavailable') > -1 || types.indexOf('pack-size') > -1) changed.push(fullLabel(v));
});
if (bad.length === chosen.length) throw new Error('These sizes could not be added: ' + bad.join(', '));
done((bad.length || changed.length ? 'Added to your order.' : count + (count === 1 ? ' item' : ' items') + ' added to your order.') +
(bad.length ? ' Not added: ' + bad.join(', ') + '.' : '') + (changed.length ? ' Quantity adjusted for stock or pack size: ' + changed.join(', ') + '.' : ''), bad.length || changed.length);
}).catch(failed);
return;
}
fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: chosen.map(function (v) { return { id: v.id, quantity: qty[v.id] }; }) }) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
.then(function () { done(count + (count === 1 ? ' item' : ' items') + ' added to your cart.'); try { d.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (err) {} })
.catch(failed);
});
foot.appendChild(sum); foot.appendChild(add); total();
} else {
var li = mk('a', 'bsv-add', 'Log in to see prices and order'); li.href = L.loginUrl(); li.addEventListener('click', stop);
foot.appendChild(mk('span', 'bsv-sum', '')); foot.appendChild(li);
}
if (pr.description) {
var det = mk('details', 'bsv-ds'); det.appendChild(mk('summary', null, 'Description and size'));
var doc = new DOMParser().parseFromString(pr.description, 'text/html');
[].forEach.call(doc.querySelectorAll('script,style,iframe,object,embed,link,form'), function (n) { n.remove(); });
[].forEach.call(doc.querySelectorAll('*'), function (n) { [].slice.call(n.attributes).forEach(function (a) { if (/^on/i.test(a.name) || a.name === 'style' || (/^(href|src)$/i.test(a.name) && /^\s*javascript:/i.test(a.value))) n.removeAttribute(a.name); }); });
var inner = mk('div'); while (doc.body.firstChild) inner.appendChild(d.importNode(doc.body.firstChild, true)), doc.body.removeChild(doc.body.firstChild);
det.appendChild(inner); body.appendChild(det);
}
var full = mk('a', 'bsv-lk', 'Open full product page'); full.href = base + 'products/' + pr.handle; full.target = '_blank'; full.rel = 'noopener'; full.addEventListener('click', stop); body.appendChild(full);
}
/* View cart: the SparkLayer cart slides in on the right, over the player. A player can pass onCart to openSheet to do it
   itself (it pauses its video and steps under the cart). Otherwise the panel opens the cart here and drops any player
   window that sits above the cart (z-index 99999) just under it until the cart closes. Returns false without SparkLayer
   (the link then opens the cart page in a new tab). */
function viewCart(from, onCart) {
if (typeof onCart === 'function') { try { onCart(); return true; } catch (e) {} }
var S = window.spark; if (!S || typeof S.openDrawer !== 'function') return false;
var lifted = [];
for (var n = from; n && n.nodeType === 1 && n !== d.body; n = n.parentElement) { var cs = getComputedStyle(n); if (cs.position === 'fixed' && (parseInt(cs.zIndex, 10) || 0) >= 99999) { lifted.push([n, n.style.zIndex]); n.style.zIndex = '99990'; } }
function back() { lifted.forEach(function (x) { x[0].style.zIndex = x[1]; }); }
try { S.openDrawer(); } catch (e) { back(); return false; }
if (lifted.length) {
var seen = false, t0 = Date.now(), t = setInterval(function () {
var sd = d.querySelector('spark-drawer'), open = !!(sd && sd.shadowRoot && sd.shadowRoot.querySelector('[class*="z-99999"]'));
if (open) { seen = true; return; }
if (!seen && Date.now() - t0 < 5000) return;   /* still opening */
clearInterval(t); back();
}, 250);
}
return true;
}
function markCart(handle) {
fetch(base + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }).then(function (c) {
var a = (c && c.attributes) || {}, st = String(a._bayeas_styles || '').split(',').filter(Boolean);
if (handle && st.indexOf(handle) < 0) st.push(handle); while (st.join(',').length > 480) st.shift();
return fetch(base + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _bayeas_video: 'shop-video', _bayeas_styles: st.join(',') } }) });
}).catch(function () {});
}
function openSheet(o) {
var sh = mk('div', 'bsv-sh'); sh.setAttribute('role', 'dialog'); sh.setAttribute('aria-label', o.title); sh.addEventListener('click', stop);
var bar = mk('div', 'bsv-shb'), bk = btn('bsv-shx', '←', o.backLabel, o.onBack);
bar.appendChild(bk); bar.appendChild(mk('span', null, 'Product details'));
var wish = L.heart(o.flash); bar.appendChild(wish.el);
var body = mk('div', 'bsv-shc'), foot = mk('div', 'bsv-ft');
L.skel(body, o.title, o.img);
sh.appendChild(bar); sh.appendChild(body); sh.appendChild(foot); o.host.appendChild(sh);
try { bk.focus({ preventScroll: true }); } catch (e) {}
fetch(base + 'products/' + o.handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
.then(function (pr) { if (!sh.isConnected) return; fill(body, foot, pr, o.flash, o.onCart); wish.bind(pr); L.reveal(body); })
.catch(function () {
if (!sh.isConnected) return; body.removeAttribute('aria-busy'); body.textContent = 'Could not load this style. ';
var l = mk('a', 'bsv-lk', 'Open the product page'); l.href = base + 'products/' + o.handle; l.target = '_blank'; l.rel = 'noopener'; body.appendChild(l);
});
return sh;
}
function pickVideo(m) {
var srcs = (m.sources || []).slice(), mp4 = srcs.filter(function (s) { return s.format === 'mp4' || /mp4/.test(s.mime_type || ''); });
mp4.sort(function (a, b) { return Math.abs((a.height || 0) - 720) - Math.abs((b.height || 0) - 720); });
if (mp4.length) return mp4[0].url;
var h = srcs.filter(function (s) { return s.format === 'm3u8'; }); return h.length ? h[0].url : null;
}
var cache = {};
function load(h, onMeta) {
if (!cache[h]) cache[h] = fetch(base + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
var v = null; (p.media || []).forEach(function (m) { if (!v && m.media_type === 'video') { var u = pickVideo(m); if (u) v = { url: u, poster: m.preview_image && m.preview_image.src }; } });
var photos = (p.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src; });
if (!photos.length && p.featured_image) photos = [p.featured_image];
var g = /(?:^|-)(by[a-z]{0,3}\d{3,5}[a-z]?)(?:-|$)/i.exec(h) || /\b(by[a-z]{0,3}\d{3,5}[a-z]?)\b/i.exec(p.title);
var it = { h: p.handle || h, title: p.title, img: p.featured_image || photos[0], price: p.price / 100, video: v, photos: photos.slice(0, 3), sn: g ? g[1].toUpperCase() : '', m: null, full: p };
L.pdp(it.h).then(function (x) { if (x.sn) it.sn = x.sn; if (x.msrp) it.m = x.msrp; if (onMeta) onMeta(); });
return it;
}).catch(function () { return null; });
return cache[h];
}
function bg(el, src, w) { if (src) el.style.backgroundImage = 'url("' + L.sized(src, w).replace(/"/g, '%22') + '")'; }
function mmss(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2); }
L.load = load; L.bg = bg; L.mmss = mmss;
L.fill = fill; L.openSheet = openSheet; L.viewCart = viewCart;
})();